export const EMPTY_FIELD_TEXT = 'Пожалуйста, заполните поле';
export const INVALID_PHONE_VALUE = 'Недопустимый формат телефона';
export const INVALID_EMAIL_VALUE = 'Недопустимый формат email';
export const BAD_PASSWORD = 'Пароль не соответствует требованиям';
export const UNACCEPTED_PRIVACY_POLICY = 'Не дано согласие на обработку персональных данных';
export const NON_CONFIRMED = 'Нужно подтвердить способ связи';